export enum LoginStep {
  EMAIL,
  PASSWORD,
}
